import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=91b9fdc4"
import script from "./ActivateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports